import React from 'react';
import AlertsContainer from '../../Componant/UiKits/Alert';

const Alert = () => {
  return (
    <div className='page-body'>
      <AlertsContainer />
    </div>
  );
};

export default Alert;
